import type { CSSProperties } from 'react'
import { C } from '../theme'
import { useContent } from '../content/ContentContext'
import { socialLinks } from '../content/socialLinks'
import { mediaUrl } from '../content/derive'

const icoStyle: CSSProperties = {
  width: 38, height: 38, borderRadius: '50%', border: '1px solid rgba(174,189,214,.35)',
  color: '#aebdd6', display: 'flex', alignItems: 'center', justifyContent: 'center',
}

export function Footer() {
  const { settings } = useContent()
  const footer = settings.footer ?? {}
  const icons = socialLinks(settings)
  const emblemUrl = mediaUrl(settings.branding?.emblem)
  const year = new Date().getFullYear()

  return (
    <footer className="sec" style={{ background: C.footer, color: '#aebdd6', padding: '44px 40px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 13 }}>
          {emblemUrl && <img src={emblemUrl} alt="" style={{ height: 40, width: 'auto' }} />}
          <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontFamily: "'Spectral',serif", fontSize: 18, color: '#fff' }}>{footer.orgName}</div>
            <div style={{ fontSize: 12, color: '#7e8fad' }}>{footer.tagline}</div>
          </div>
        </div>
        {icons.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {icons.map(({ href, label, Icon }) => (
              <a key={label} href={href} target="_blank" rel="noopener" title={label} className="footer-ico" style={icoStyle}>
                <Icon size={label === 'YouTube' ? 19 : 17} title={label} />
              </a>
            ))}
          </div>
        )}
        <div style={{ fontSize: 13, color: '#7e8fad', textAlign: 'right' }}>
          {[footer.verse, `© ${year} ${footer.orgName ?? ''}`.trim()].filter(Boolean).join(' · ')}
          {footer.legal && (
            <>
              <br />
              <span style={{ fontSize: 12 }}>{footer.legal}</span>
            </>
          )}
        </div>
      </div>
    </footer>
  )
}
